import { Add } from "@mui/icons-material";
import { Box, Button, ButtonBase, Pagination, Typography } from "@mui/material";
import DashboardTabs from "components/dashboard/dashboard-tabs";
import MyListingList from "components/my-listing/list";
import ListingTypes from "components/my-listing/listing-types";
import SearchSection from "components/my-listing/search-input";
import { ROUTES } from "constants/routes";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchOwnerListing } from "slices/dashboardReducer";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import { getPaginationCountText } from "utils/messages.util";
import useQuery from "utils/router.util";

const MyListingPage = () => {
  const { dashboardReducer }: any = useAppSelector((state) => state);
  const dispatch = useAppDispatch();
  const query = useQuery();
  const navigate = useNavigate();
  const [searchString, setSearchString] = useState("");
  const [reloadList, setReloadList] = useState(false);

  useEffect(() => {
    const qType = query.get("type");
    const qPage = query.get("page");
    dispatch(
      fetchOwnerListing({
        data: {
          type: qType || "all",
          page: qPage || 1,
          searchString,
        },
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query, searchString, reloadList]);

  const redirectWithQuery = (value: string) => {
    const qType: any = query.get("type") || "all";
    var searchParams = new URLSearchParams(window.location.search);
    searchParams.set("page", value.toString());
    searchParams.set("type", qType.toString());
    navigate(`${ROUTES.LISTING}?${searchParams}`);
  };

  return (
    <Box>
      <DashboardTabs tab="listing" />
      <Box
        sx={{
          px: "4%",
          py: "15px",
          borderBottom: {
            sm: "1px solid #E2E2E2",
            xs: "1px solid #E2E2E2",
            md: "0px solid #E2E2E2",
            lg: "0px solid #E2E2E2",
            xl: "0px solid #E2E2E2",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: {
                md: "24px",
                lg: "24px",
                xl: "24px",
                sm: "16px",
                xs: "16px",
              },
              lineHeight: "34px",
              flex: 1,
            }}
          >
            Manage Listing
          </Typography>
          <Box
            sx={{
              flex: 1,
              display: {
                md: "flex",
                lg: "flex",
                xl: "flex",
                sm: "none",
                xs: "none",
              },
              gap: "15px",
            }}
          >
            <SearchSection
              placeholder="Search your listing like tractor or attachments…"
              onChange={({ target }: any) => {
                setSearchString(target.value);
              }}
            />
            <Button
              variant="contained"
              startIcon={<img alt="" src="/assets/img/icons/add.svg" />}
              sx={{ borderRadius: "10px", fontWeight: 500, fontSize: "15px" }}
              onClick={() => navigate("/list-equipment")}
            >
              Add New Listing
            </Button>
          </Box>
          <Box
            sx={{
              display: {
                md: "none",
                lg: "none",
                xl: "none",
                sm: "flex",
                xs: "flex",
              },
              gap: "15px",
            }}
          >
            <ListingTypes selection={true} />
            <ButtonBase
              sx={{
                background: "#6E8C20",
                borderRadius: "10px",
                height: "32px",
                width: "32px",
              }}
              onClick={() => navigate("/list-equipment")}
            >
              <img alt="" src="/assets/img/icons/add.svg" />
            </ButtonBase>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: {
            md: "none",
            lg: "none",
            xl: "none",
            sm: "flex",
            xs: "flex",
          },
          px: "4%",
          py: "15px",
        }}
      >
        <SearchSection
          placeholder="Search your listing like tractor or attachments…"
          onChange={({ target }: any) => {
            setSearchString(target.value);
          }}
        />
      </Box>

      <Box
        sx={{
          display: {
            md: "flex",
            lg: "flex",
            xl: "flex",
            sm: "none",
            xs: "none",
          },
        }}
      >
        <ListingTypes selection={false} />
      </Box>

      <Box sx={{ px: "4%", py: "25px" }}>
        <Box>
          <MyListingList
            setReloadList={() => setReloadList(!reloadList)}
            list={dashboardReducer?.list}
          />
        </Box>
        {dashboardReducer?.list?.length > 0 && (
          <Box
            sx={{
              display: "flex",
              py: "20px",
              justifyContent: "space-between",
              alignItems: "center",

              flexWrap: "wrap",
              gap: "20px",
            }}
          >
            <Box>
              <Typography
                sx={{ color: "#A2A2A2", fontSize: "13px", fontWeight: 600 }}
              >
                {getPaginationCountText(
                  query.get("page") ? Number(query.get("page")) : 1,
                  dashboardReducer?.listMeta?.totalPages,
                  dashboardReducer?.listMeta?.totalRecords,
                  6
                )}
              </Typography>
            </Box>
            <Pagination
              count={dashboardReducer?.listMeta?.totalPages}
              shape="rounded"
              page={query.get("page") ? Number(query.get("page")) : 1}
              onChange={(_, page) => {
                redirectWithQuery(page.toString());
              }}
              color="primary"
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default MyListingPage;
